import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import { AuthProvider } from './auth/AuthContext.jsx';
import { SaveToastProvider } from './components/SaveToast.jsx';
import './styles/global.css';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <SaveToastProvider>
          <App />
        </SaveToastProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
